import DateText from './dateText.view';

export default DateText;
